// =============================
// File: src/components/user/ReferralCodeShare.jsx
// =============================
import React, { useState } from 'react';
import { Copy, Share2, Check } from 'lucide-react';

function ReferralCodeShare({ referralCode }) {
  const [copied, setCopied] = useState(false);

  function copyToClipboard() {
    if (!referralCode) return;
    
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  function shareReferralCode() {
    if (!referralCode) return;

    const shareText = `¡Únete a Fast Max con mi código de referido ${referralCode} y obtén 50% de descuento en tus primeros 10 envíos! 🚀`;
    const shareUrl = `${window.location.origin}/register?ref=${referralCode}`;

    if (navigator.share) {
      navigator.share({
        title: 'Únete a Fast Max',
        text: shareText,
        url: shareUrl
      }).catch(err => console.log('Error sharing:', err));
    } else {
      copyToClipboard();
    }
  }

  if (!referralCode) return null;

  return (
    <div className="bg-gradient-to-br from-brand-primary to-[#8B2659] rounded-xl shadow-lg p-6 text-white">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-extrabold font-montserrat mb-1">Tu Código de Referido</h3>
          <p className="text-white/80 text-sm font-montserrat">
            Comparte este código y gana S/ 1.00 por cada envío
          </p>
        </div>
        <Share2 className="w-6 h-6 text-white/60" />
      </div>

      <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4 mb-4">
        <div className="text-center">
          <p className="text-white/60 text-xs font-montserrat font-medium mb-2">CÓDIGO</p>
          <p className="text-3xl font-extrabold font-montserrat tracking-wider">
            {referralCode}
          </p>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={copyToClipboard}
          className="flex-1 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-montserrat font-semibold py-3 px-4 rounded-lg transition-all flex items-center justify-center gap-2"
        >
          {copied ? (
            <>
              <Check className="w-4 h-4" />
              Copiado
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              Copiar Código
            </>
          )}
        </button>

        <button
          onClick={shareReferralCode}
          className="flex-1 bg-white text-brand-primary hover:bg-white/90 font-montserrat font-semibold py-3 px-4 rounded-lg transition-all flex items-center justify-center gap-2 shadow-lg"
        >
          <Share2 className="w-4 h-4" />
          Compartir
        </button>
      </div>

      <div className="mt-4 pt-4 border-t border-white/20">
        <p className="text-white/80 text-xs font-montserrat text-center">
          🎁 Tus referidos obtienen <span className="font-bold">50% de descuento</span> en sus primeros 10 envíos
        </p>
      </div>
    </div>
  );
}

export default ReferralCodeShare;